<template>
  <div class="input multiselect-input" v-bind:class="{'is-invalid': error}">
    <multiselect
      v-bind:class="{'material': material, 'required': requiredField}"
      v-model="content"
      id="id"
      :options="options"
      :label="label"
      :trackBy="trackBy"
      :multiple="multiple"
      :searchable="searchable"
      :closeOnSelect="closeOnSelect"
      :placeholder="componentPlaceholder"
      @open="hasFocus=true"
      @close="hasFocus=false"
      @input="emitContent"
      @search-change="emitSearchChange" />

    <div v-bind:class="{'has-value': hasValue, 'has-focus': hasFocus}">
      <input-label :isRequired="isRequired" for-id="id" style="z-index:50">
        {{placeholder}}
      </input-label>
    </div>

    <input-footer :error="error" />
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import InputLabel from '../../../components/ui/inputs/InputLabel.vue'
  import InputFooter from '../../../components/ui/inputs/InputFooter.vue'

  export default {
    data() {
      return {
        content: this.value,
        componentPlaceholder: '',
        hasFocus: false
      }
    },

    props: {
      value: [Object, Array, String],
      options: Array,
      label: String,
      keyProp: String,
      trackBy: String,
      placeholder: String,
      error: String,
      multiple: Boolean,
      searchable: Boolean,
      closeOnSelect: Boolean,
      material: Boolean,
      isRequired: Boolean
    },

    components: {
      Multiselect,
      InputLabel,
      InputFooter
    },

    methods: {
      emitContent() {
        let result = this.content && this.keyProp ? this.content[this.keyProp] : this.content
        this.$emit('input', result)
      },
      emitSearchChange(query) {
        this.$emit('search-change', query)
      }
    },

    mounted() {
      this.componentPlaceholder = this.searchable ? 'Search' : this.placeholder
    },

    computed: {
      hasValue() {
        return this.content && this.content[this.keyProp]
      },
      requiredField() {
        return this.isRequired && this.error
      }
    }
  }
</script>

<style lang="sass">
  @import 'vue-multiselect/dist/vue-multiselect.min.css'
  @import '../../../styles/base/variables'

  .multiselect-input
    position: relative

    &.is-invalid
      .validation-error
        color: $color-error

      .has-focus
        .input-label
          color: $color-error

  .multiselect
    min-height: 30px
    width: 150px
    font-size: 10px
    line-height: 12px

    .multiselect__select
      display: none

    .multiselect__input,
    .multiselect__single
      font-size: 10px
      font-family: sans-serif
      color: black
      font-weight: 400

    .multiselect__tags
      border-radius: 0
      border-color: $color-border
      padding: 0 5px
      min-height: 30px
      font-size: 10px
      display: flex
      align-items: center

      .multiselect__tags-wrap
        position: relative
        top: 2px
        display: flex
        flex-wrap: wrap

        .multiselect__tag
          background: $color-primary

          .multiselect__tag-icon
            top: -3px

            &::after
              color: $color-side-nav
              transition: color .2s

            &:hover
              background: $color-primary

              &::after
                color: white

      .multiselect__single
        padding: 0
        margin: 0

      .multiselect__placeholder
        margin: 0
        font-weight: 400
        color: black

    .multiselect__content-wrapper
      border-radius: 0

      ul.multiselect__content
        li.multiselect__element
          .multiselect__option
            padding: 6px
            min-height: 20px

            &::after
              content: ''

            &.multiselect__option--highlight
              background: $color-primary

            span
              font-weight: 400

    &.material
      width: 100%
      padding-top: 20px

      .multiselect__tags
        height: 46px
        width: 100%
        padding: 0
        border: 0

        .multiselect__input,
        .multiselect__single
          font-size: 12px
          font-weight: 300
          color: $color-text
          padding: 0
          margin: 0
          top: 2px

        .multiselect__single
          font-weight: 400

        .multiselect__placeholder
          display: none

        &::after
          width: 100%
          height: 2px
          position: absolute
          display: inline-block
          content: ''
          -webkit-transition: background-color 0.3s ease-in-out
          transition: background-color 0.3s ease-in-out
          bottom: 0
          left: 0
          background: #bbc1c2

      &.multiselect--active > .multiselect__tags > span.multiselect__placeholder
        display: inline-block

      &.multiselect--active > .multiselect__tags::after
        background: $color-primary

      &.required
        .multiselect__tags::after
          background: $color-error

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/Multiselect.vue